"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var router_1 = require("@angular/router");
var common_1 = require("@angular/common");
var form_module_1 = require("../form/form.module");
var term_module_1 = require("../term/term.module");
var payment_service_1 = require("./services/payment.service");
var payment_component_1 = require("./components/payment.component");
var payment_routes_1 = require("./payment.routes");
var common_module_1 = require("../common/common.module");
var core_1 = require("@angular/core");
var core_2 = require("@ngx-translate/core");
var PaymentModule = (function () {
    function PaymentModule() {
    }
    return PaymentModule;
}());
PaymentModule = __decorate([
    core_1.NgModule({
        imports: [
            core_2.TranslateModule,
            form_module_1.TRTFormModule,
            common_1.CommonModule,
            common_module_1.TRTCommonModule,
            router_1.RouterModule,
            term_module_1.TermModule,
            payment_routes_1.PaymentRoutingModule
        ],
        exports: [payment_component_1.PaymentComponent],
        declarations: [payment_component_1.PaymentComponent],
        providers: [payment_service_1.PaymentService],
    })
], PaymentModule);
exports.PaymentModule = PaymentModule;
var PCPaymentModule = (function () {
    function PCPaymentModule() {
    }
    return PCPaymentModule;
}());
PCPaymentModule = __decorate([
    core_1.NgModule({
        imports: [
            core_2.TranslateModule,
            form_module_1.TRTFormModule,
            common_1.CommonModule,
            common_module_1.TRTCommonModule,
            router_1.RouterModule,
            term_module_1.TermModule,
            payment_routes_1.PCPaymentRoutingModule
        ],
        exports: [payment_component_1.PCPaymentComponent],
        declarations: [payment_component_1.PCPaymentComponent],
        providers: [payment_service_1.PaymentService],
    })
], PCPaymentModule);
exports.PCPaymentModule = PCPaymentModule;
